/**
 * Coach-clip ids (Phase B).
 *
 * The playback machinery keys everything on a single clip-id string. Normally
 * that's a practice message id. BYO intake guide turns aren't stored as
 * messages (they live in the session's intake log), so they use a compound id —
 * `intake:{sessionId}:{index}` — that the audio backends route to the
 * intake-audio endpoint instead of the message-audio one. These helpers build
 * and parse that form so the rest of the voice code can stay id-keyed and blind
 * to the difference.
 */
const PREFIX = "intake:";

export function intakeClipId(sessionId: string, index: number): string {
  return `${PREFIX}${sessionId}:${index}`;
}

export function parseIntakeClipId(
  id: string,
): { sessionId: string; index: number } | null {
  if (!id.startsWith(PREFIX)) return null;
  const rest = id.slice(PREFIX.length);
  // Session ids don't contain ':', but split from the right so a future one
  // couldn't break the index.
  const sep = rest.lastIndexOf(":");
  if (sep <= 0) return null;
  const sessionId = rest.slice(0, sep);
  const index = Number(rest.slice(sep + 1));
  if (!sessionId || !Number.isInteger(index) || index < 0) return null;
  return { sessionId, index };
}
